export default __webpack_public_path__ + "static/Entenda0045-27e824dc51080d5f67de467d3f70f00d.jpg";